import {
  getAssetMetricsCmmsData,
  getAssetHierarchy,
} from '../api/asset-metrics-dashboardAPI';

export const assetMetricsCmmsDataProviderByAssetIds = (assetIds = []) => {
  let cachedResponse;
  let cachedHierarchy;

  const normalisedAssetIds = new Set(assetIds.map(String));

  const loadData = async () => {
    if (!cachedResponse) {
      cachedResponse = await getAssetMetricsCmmsData();
    }

    return cachedResponse;
  };

  const loadHierarchy = async () => {
    if (!cachedHierarchy) {
      cachedHierarchy = await getAssetHierarchy();
    }
    return cachedHierarchy;
  };

  const filterByIds = (assets) =>
    assets.filter((a) => normalisedAssetIds.has(String(a.id)));

  return {
    async getAssetTypes() {
      const hierarchy = await loadHierarchy();
      return hierarchy?.assetTypes || [];
    },

    async getAssetClasses() {
      const hierarchy = await loadHierarchy();
      return hierarchy?.assetClasses || [];
    },

    async getAssetGroups() {
      const hierarchy = await loadHierarchy();
      return hierarchy?.assetGroups || [];
    },

    async getAreas() {
      const hierarchy = await loadHierarchy();
      return hierarchy?.areas || [];
    },

    async getDepartments() {
      const hierarchy = await loadHierarchy();
      return hierarchy?.departments || [];
    },

    async getAssets() {
      const hierarchy = await loadHierarchy();
      const assets = hierarchy?.assets || [];

      return filterByIds(assets).map((asset) => ({
        id: asset.id,
        assetName: asset.name,
        assetSerial: asset.serial,
        assetDescription: asset.assetDescription,
        assetImage: asset.assetImage,
      }));
    },

    async loadAssetsForFilters() {
      const data = await loadData();
      const assets = data?.assets || [];

      return filterByIds(assets);
    },

    async getAvailableMeters() {
      const assets = await this.loadAssetsForFilters();

      const allMeters = assets.flatMap(
        (asset) =>
          asset.meters?.map(({ id, unit }) => ({ id, unit })) || []
      );

      return [...new Map(allMeters.map((m) => [m.id, m])).values()];
    },

    resolveAssetName(_a, _b, _c, _d, _e, assetId) {
      if (!cachedHierarchy?.assets) return assetId;
      const found = cachedHierarchy.assets.find((a) => a.id === assetId);
      if (!found) return assetId;
      return `${found.name} (${found.serial})`;
    },

    getAssetGroupingMetadata(assetId) {
      if (!cachedHierarchy?.assets) return undefined;
      const found = cachedHierarchy.assets.find(
        (a) => String(a.id) === String(assetId)
      );
      if (!found) return undefined;

      return {
        id: found.id,
        assetName: found.name,
        assetSerial: found.serial,
        assetDescription: found.assetDescription,
        assetImage: found.assetImage,
        assetTypeId: found.assetType,
        assetGroupId: found.assetGroup,
        departmentId: found.department,
        assetGroup: found.assetGroup,
        assetClass: found.assetClass,
        department: found.department,
      };
    },
  };
};
export default assetMetricsCmmsDataProviderByAssetIds;
